export const CustomSignInPageTheme = {
    BackstageSignInPage: {
        styleOverrides: {
            container: {
                height: '100%',
                width: '100%',
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',

                '& li': {
                    height: '640px',
                    width: '100%',
                    position: 'relative',

                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        height: '100%',
                        width: '50%',
                        borderBottomLeftRadius: 30,
                        borderTopLeftRadius: 30,
                        backgroundImage: 'url("/images/box-login.jpg")',
                        backgroundSize: 'cover',
                        backgroundPosition: 'top',
                        boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)'
                    },

                    '& > div:first-child': {
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        height: '100%',
                        width: '50%',
                        borderBottomRightRadius: 30,
                        borderTopRightRadius: 30,

                        '& button': {
                            width: '100%',
                            color: '#FFF',
                            background: '#1351B4'
                        },

                        '& > div:first-child': {
                            '& span': {
                                fontSize: 32,
                                position: 'relative',
                                fontWeight: 800,
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '12px',

                                '&::before': {
                                    content: '""',
                                    display: 'inline-block',
                                    width: '48px',
                                    height: '48px',
                                    backgroundImage: 'url("/olimpia-logo.svg")',
                                    backgroundSize: 'contain',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center',
                                }
                            }
                        },
                    },

                }
            },
            item: {
                maxWidth: 1000,
            }
        }
    }
}